import { callApi } from "@/api/api-core";

export const setEmailDelivery = function(
    orderId,
    cardIdentificationId,
    cardIdentificationCharacters,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        cardIdentificationId,
        cardIdentificationCharacters
    };

    return callApi(
        "POST",
        "v1/delivery/email/setdelivery",
        requestData,
        ownerHandlesFailure
    );
};

export const setSnailmailDelivery = function(
    orderId,
    inputDeliveryAddress,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        termsAccepted: true,
        inputDeliveryAddress
    };

    return callApi(
        "POST",
        "v1/delivery/snailmail/setdelivery",
        requestData,
        ownerHandlesFailure
    );
};

export const fetchSnailmailInfo = function(ownerHandlesFailure) {
    const requestData = {};

    return callApi(
        "POST",
        "v1/delivery/snailmail/info",
        requestData,
        ownerHandlesFailure
    );
};
